import React from 'react';
import styled from 'styled-components/macro';

import Spinner from 'components/Spinner';

import { flexCenter } from 'styles/styled-mixins';


const Loading = ({ className }) => (
    <Container className={className}>
        <Spinner/>
    </Container>
);


export default Loading;


const Container = styled.div`
    width: 100%;
    height: 100%;
    
    font-size: 10rem;
    
    ${flexCenter};
`;
